<template>
    <jet-confirmation-modal :show="show" type="danger" @close="$emit('close')">
        <template #title>
            {{ trans('quality_assurance.configuration.modal.delete_sla.title') }}
        </template>

        <template #content>
            <div v-if="sla">
                <p>
                    {{
                        trans('quality_assurance.configuration.modal.delete_sla.warning', {
                            sla: `${sla.maintainerName} · ${sla.typeLabel}`,
                            count: sla.coveredAssets?.length ?? 0,
                        })
                    }}
                </p>
                <sla-affected-assets-section
                    :assets="sla.coveredAssets || []"
                    :heading="trans('quality_assurance.configuration.modal.sla.covered_assets')"
                />
            </div>
        </template>

        <template #footer>
            <jet-button :destructive="true" :isProcessing="isProcessing" variant="secondary" @click.stop="$emit('confirm')">
                {{ trans('general.action.delete') }}
            </jet-button>
        </template>
    </jet-confirmation-modal>
</template>

<script setup>
import JetButton from '@/Jetstream/Button.vue';
import JetConfirmationModal from '@/Jetstream/ConfirmationModal.vue';
import SlaAffectedAssetsSection from '@/Pages/Stakeholders/Maintainers/SlaAffectedAssetsSection.vue';
import { trans } from '@/mixins/i18n.js';

defineProps({
    show: { type: Boolean, default: false },
    sla: { type: Object, default: null },
    isProcessing: { type: Boolean, default: false },
});

defineEmits(['close', 'confirm']);
</script>
